var _style, _g, _g2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPattern2(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 305.9 205.1",
    style: {
      enableBackground: "new 0 0 305.9 205.1"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:none;stroke:#FCAD9A;stroke-width:3;stroke-linecap:round;stroke-miterlimit:10;}\r\n\t.st1{fill:#2163FF;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Line"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4200",
    transform: "translate(-751 -1984.575)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1105",
    className: "st0",
    d: "M755.3,2156.5c-2.3-27.9,11-51,30.3-65.1s44.1-20.6,69.1-25.4 c60.9-11.7,127.2-15.5,174.8-49.3c10.8-7.7,20.7-17.1,25.6-30.2"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3523",
    transform: "translate(759 2167.642) rotate(90)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_64",
    transform: "matrix(2.535182e-06 1 -1 2.535182e-06 -1225.5699 2735.573)",
    className: "st1",
    cx: -1980.6,
    cy: 755,
    rx: 4,
    ry: 4
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_65",
    transform: "matrix(2.535182e-06 1 -1 2.535182e-06 -1211.5699 2721.573)",
    className: "st1",
    cx: -1966.6,
    cy: 755,
    rx: 4,
    ry: 4
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Dots"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPattern2);
export default __webpack_public_path__ + "static/media/pattern2.34230c57.svg";
export { ForwardRef as ReactComponent };